import styled from 'styled-components';
import primitives from '@veneer/primitives';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  padding: 0px ${primitives.layout.size6}px;
  color: ${primitives.color.gray12};
`;

export const Counter = styled.p`
  color: ${primitives.color.gray9};
`;

export const StatusBadge = styled.div`
  display: flex;
  height: ${primitives.layout.size3}px;
`;

export const StatusDescription = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StatusIndicator = styled.div`
  max-width: 60%;
  display: flex;
  gap: ${primitives.layout.size2}px;
  align-items: center;
`;

export const StatusCounterArea = styled.div`
  display: flex;
  max-width: 40%;
  align-items: center;
  gap: ${primitives.layout.size3}px;
  width: 41.6px;
`;
